import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  events = 'events',
  event = 'event',
}

enum ExternalRoutesIds {
  entity = 'entity',
  entities = 'entities',
}

// root route
export const [eventIndexRouteImplRef, eventIndexRouteRef] =
  createRootRouteRefsPair({ id: RoutesIds.events });

export const rootRouteRef = eventIndexRouteImplRef;

// sub-routes within the plugin
export const [eventRouteImplRef, eventRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.event,
  parent: rootRouteRef,
  path: '/:id',
});

// external routes to other plugins
export const entityRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entity,
  params: ['id'],
  optional: true,
});

export const entitiesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entities,
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  events: eventIndexRouteImplRef,
  event: eventRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // sub-routes within the plugin
  events: eventIndexRouteRef,
  event: eventRouteRef,

  // external routes to other plugins
  entity: entityRouteRef,
  entities: entitiesRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
